import React, { useState, useMemo } from "react";

// Components atoms
import Search from "components/atomic/shared/search";
import SelectDateRange from "components/atomic/shared/select-date-range";
import Pagination from "components/atomic/shared/pagination";

// Components molecules
import Tabs from "components/molecules/showing-activity/tabs";

// Components organisms
import FeedTable from "components/organism/showing-activity/feed-table";

// API
import { useGetActivityFeedList } from "api/showing-activity/query";


const Feed = () => {
  const [limit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [start, end] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const params = {
    _limit: limit,
    page: currentPage,
    ...(searchQuery && { q: searchQuery }),
    ...(start && end && { start_date: formatDate(start), end_date: formatDate(end) }),
  };

  const { data, isLoading } = useGetActivityFeedList({ params });

  const feedData = useMemo(() => {
    return data?.data?.data || [];
  }, [data]);

  const totalPages = useMemo(() => {
    const total = parseInt(data?.headers?.["x-total"] || 0);
    const perPage = parseInt(data?.headers?.["x-per-page"] || limit);
    return Math.ceil(total / perPage);
  }, [data, limit]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const handleDateChange = (update) => {
    setDateRange(update);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="py-2 px-4 bg-[#FAFAFA]">
      <div className="bg-white rounded-[4px]">
        <div className="px-4 pt-2 flex items-center justify-between gap-2">
          <Tabs />

          <div className="flex items-center gap-2">
            <Search placeholder="Cari marketing dengan nama" onChange={handleSearch} />
            <SelectDateRange startDate={start} endDate={end} onChange={handleDateChange} />
          </div>
        </div>
        <div className="px-4 py-2">
          <FeedTable data={feedData} isLoading={isLoading} isSearch={!!searchQuery} />
          
          <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default Feed;
